import get from 'lodash.get';

const getServiceAPIUrl = (rootState) => get(rootState, 'config.common.ws-api.url', '');

export default getServiceAPIUrl;
